module.exports = __webpack_public_path__ + "static/steven-pinker-f108efcb795a6b127beeb015be904c0d.jpg";